export default "__VITE_ASSET__j5R$7PRu__"